@if (tabsContent$ | async; as tabsContent) {
  <ul
    ngbNav
    #nav="ngbNav"
    [(activeId)]="active"
    class="nav-tabs"
    [destroyOnHide]="false"
    >
    @for (tabContent of tabsContent; track trackByTabsContent($index, tabContent); let count = $count; let isLast = $last) {
      <li [ngbNavItem]="tabContent.index"
        >
        <button ngbNavLink class="nav-link" translate>
          {{ tabContent.title }}
          @if (tabContent.formGroupName && this.form.controls[tabContent.formGroupName]?.touched && this.form.controls[tabContent.formGroupName]?.invalid) {
            <span class="ps-1">
              @if (errorsDescription$ | async; as errors) {
                @for (error of errors.children; track error) {
                  @if (error.groupName === tabContent.formGroupName) {
                    <span class="badge text-bg-danger"
                    >{{ error.count }}</span>
                  }
                }
              } @else {
                <span class="dot"></span>
              }
            </span>
          }
        </button>
        <ng-template ngbNavContent>
          <ng-container *ngComponentOutlet="tabContent.component"/>
        </ng-template>
      </li>
    }
  </ul>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
}
